import { render, staticRenderFns } from "./ApproveRejectIssuerDialog.vue?vue&type=template&id=4a256b08"
import script from "./ApproveRejectIssuerDialog.vue?vue&type=script&lang=js"
export * from "./ApproveRejectIssuerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports